export const socialPill = () => {

	window.addEventListener('scroll', function() {
	    const socialPill = document.querySelector('.fixed-social-pill');
	    
	    if (window.scrollY > 300) {
	        socialPill.classList.add('fade-off');
	    } else {
	        socialPill.classList.remove('fade-off');
	    }
	});
}